import React from 'react';
import GeneralList from './GeneralList';
import { studentConfig } from './Config';

export default function StudentList() {
  return (
    <GeneralList
      title={studentConfig.title}
      addLabel={studentConfig.addLabel}
      icon={studentConfig.icon}
      fetchUrl={studentConfig.fetchUrl}
      submitUrl={studentConfig.submitUrl}
      createDataFunction={studentConfig.createDataFunction}
      rowHeaders={studentConfig.rowHeaders}
      editFields={studentConfig.fields}
      displayFields={studentConfig.displayFields}
      detailFields={studentConfig.detailFields}
    />
  );
}
